<template>
  <div class="todo-footer">
    <span>{{ todoService.viewTodoList.length }}个</span>
    <button
      type="button"
      :class="{ active: todoService.viewStatus === 0 }"
      @click="todoService.updateViewStatus(0)"
    >
      All
    </button>
    <button
      type="button"
      :class="{ active: todoService.viewStatus === TodoStatus.Active }"
      @click="todoService.updateViewStatus(TodoStatus.Active)"
    >
      Active
    </button>
    <button
      type="button"
      :class="{ active: todoService.viewStatus === TodoStatus.Completed }"
      @click="todoService.updateViewStatus(TodoStatus.Completed)"
    >
      Complete
    </button>
    <button
      type="button"
      class="btn-del-all"
      @click="todoService.clearCompletedTodos()"
    >
      清除全部已完成
    </button>
  </div>
</template>

<script lang="ts">
import { TodoService, TodoStatus } from "@/services/todo.service";
import { useService } from "use-vue-service";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const todoService = useService(TodoService);
    return {
      todoService,
      TodoStatus
    };
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.todo-footer {
  line-height: 32px;

  .active {
    color: red;
  }

  .btn-del-all {
    margin-top: 3px;
    float: right;
  }
}
</style>
